/* ==========================================================================
   Jukebox × Barbie — landing page interactions
   - Scale the fixed 1440 frame down to fit narrow viewports (zoom)
   - Quantity stepper · scent tabs · thumbnail swap · review drag-scroll
   Scoped to each .barbie-landing instance; multi-instance safe (desktop + mobile).
   ========================================================================== */
(function () {
  // Safe to include from multiple sections — only the first copy runs.
  if (window.__barbieLandingJSInit) return;
  window.__barbieLandingJSInit = true;

  function init(root) {
    if (!root || root.dataset.blInit === "1") return;
    root.dataset.blInit = "1";

    /* ---- Scale the 1440 frame to ALWAYS fill the viewport width ----
       (scales up on screens wider than 1440 so sections are full-bleed; down on narrow) */
    var frame = root.querySelector("[data-bl-frame]");
    function fit() {
      if (!frame) return;
      var w = document.documentElement.clientWidth || window.innerWidth;
      frame.style.zoom = w / 1440;
    }
    fit();
    window.addEventListener("resize", fit);

    /* ---- Scroll-linked letter reveal on the editorial copy ----
       Letters fade in one-by-one (left→right) as the line scrolls up through
       the viewport, and fade back out on the way up. Pure scroll-position →
       opacity ("scrubbed"), so reversing is automatic. */
    function revealCopy(copy) {
      if (!copy || copy.dataset.blReveal === "1") return;
      copy.dataset.blReveal = "1";

      /* PART 1 — SPLIT: wrap each character in its own span. We walk TEXT NODES
         (not innerText) so the existing .ink / .solid colour spans are kept.
         Letters of a word are grouped inside a .bl-word wrapper (white-space:
         nowrap) so the line can ONLY break at real spaces between words — never
         mid-word. Spaces stay as ordinary (breakable) space letters. */
      var letters = [];
      var walker = document.createTreeWalker(copy, NodeFilter.SHOW_TEXT, null);
      var textNodes = [], node;
      while ((node = walker.nextNode())) textNodes.push(node);
      function makeLetter(ch) {
        var s = document.createElement("span");
        s.className = "bl-letter";
        s.textContent = ch;
        letters.push(s);
        return s;
      }
      textNodes.forEach(function (tn) {
        var frag = document.createDocumentFragment();
        // split on whitespace runs, keeping the delimiters: ["word", " ", "word", …]
        tn.textContent.split(/(\s+)/).forEach(function (token) {
          if (token === "") return;
          if (/^\s+$/.test(token)) {
            // whitespace: breakable space letters (line may wrap here)
            Array.from(token).forEach(function () { frag.appendChild(makeLetter(" ")); });
          } else {
            // word: letters kept together so they never break mid-word
            var word = document.createElement("span");
            word.className = "bl-word";
            Array.from(token).forEach(function (ch) { word.appendChild(makeLetter(ch)); });
            frag.appendChild(word);
          }
        });
        tn.parentNode.replaceChild(frag, tn);
      });
      if (!letters.length) return;
      copy.classList.add("bl-reveal-ready"); // now CSS hides the letters

      /* PART 2 — SCROLL PROGRESS: 0 when the line's top hits the bottom of the
         viewport, 1 when its bottom hits the top. Position-based, so scrolling
         up lowers it and the reveal rewinds for free. */
      function progress() {
        var r = copy.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh - r.top) / (vh + r.height);
        return Math.min(1, Math.max(0, p));
      }

      /* PART 3 — OPACITY MAPPING: each letter gets its own slice of the 0→1
         timeline, offset by its index → left-to-right stagger. WINDOW = how
         much neighbouring letters overlap (bigger = softer wave). */
      var WINDOW = 0.5;
      function render(p) {
        var n = letters.length;
        for (var i = 0; i < n; i++) {
          var start = (i / n) * (1 - WINDOW);
          var local = (p - start) / WINDOW;
          letters[i].style.opacity = Math.min(1, Math.max(0, local));
        }
      }

      /* rAF: coalesce scroll bursts into one paint-aligned update. */
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { render(progress()); ticking = false; });
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      render(progress()); // initial state
    }
    // Apply to both the desktop copy and its mobile twin.
    revealCopy(root.querySelector(".bl-editorial__copy"));
    revealCopy(root.querySelector(".bl-m-ed__copy"));

    /* ---- Sliding-text-button effect (ref: Framer "sliding text button") ----
       On hover the label rolls up (duplicate slides in from below) and the arrow
       slides diagonally out/in. Build the 2-copy structure once per CTA. */
    function dup(content, cls, asHtml) {
      var track = document.createElement("span");
      track.className = cls;
      var a = document.createElement("span");
      var b = document.createElement("span"); b.setAttribute("aria-hidden", "true");
      if (asHtml) { a.innerHTML = content; b.innerHTML = content; }
      else { a.textContent = content; b.textContent = content; }
      track.appendChild(a); track.appendChild(b);
      return track;
    }
    /* Figma's CTA arrow is a ↗ glyph (Figtree Bold); rendered as a vector here so it's
       crisp and identical across browsers/fonts. currentColor follows .bl-cta__arrow. */
    var ARROW_SVG = '<svg class="bl-cta__arrow-svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7.5 16.5 17 7M10 7h7v7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    root.querySelectorAll(".bl-cta").forEach(function (btn) {
      var label = btn.querySelector(".bl-cta__label");
      if (label && label.dataset.blSlide !== "1") {
        label.dataset.blSlide = "1";
        var lt = label.textContent;
        label.textContent = "";
        label.appendChild(dup(lt, "bl-cta__label-track"));
      }
      var arrow = btn.querySelector(".bl-cta__arrow");
      if (arrow && arrow.dataset.blSlide !== "1") {
        arrow.dataset.blSlide = "1";
        arrow.textContent = "";
        arrow.appendChild(dup(ARROW_SVG, "bl-cta__arrow-track", true));
      }
    });

    /* ---- Quantity stepper (one per buy box: desktop + mobile) ---- */
    root.querySelectorAll("[data-bl-qty]").forEach(function (qty) {
      var input = qty.querySelector("input");
      var dec = qty.querySelector("[data-bl-dec]");
      var inc = qty.querySelector("[data-bl-inc]");
      if (!input) return;
      if (dec) dec.addEventListener("click", function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (inc) inc.addEventListener("click", function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      input.addEventListener("change", function () {
        var v = parseInt(input.value, 10);
        input.value = (isNaN(v) || v < 1) ? 1 : v;
      });
    });

    /* ---- Scent tabs (scoped per buy box via [data-bl-scope]) ----
       Switches the whole scent card: active tab → front, panel colour, soap +
       strip image, subcopy and "smells like" all swap to the selected scent. */
    root.querySelectorAll("[data-bl-tab]").forEach(function (t) {
      t.addEventListener("click", function () {
        var scope = t.closest("[data-bl-scope]") || root;
        scope.querySelectorAll("[data-bl-tab]").forEach(function (x) {
          x.setAttribute("aria-selected", x === t ? "true" : "false");
        });
        var d = t.dataset;
        var vidField = scope.querySelector("[data-bl-vid-field]");
        if (vidField && d.blVid) vidField.value = d.blVid;
        var card = scope.querySelector("[data-bl-scent-card]");
        if (card && d.blScent) card.setAttribute("data-bl-active", d.blScent);
        function put(sel, val, attr) {
          var el = scope.querySelector(sel);
          if (!el || val == null || val === "") return;
          if (attr) el.setAttribute(attr, val); else el.textContent = val;
        }
        put("[data-bl-smell-out]", d.blSmell);
        put("[data-bl-sub-out]", d.blSub);
        put("[data-bl-soap-out]", d.blSoap, "src");
        put("[data-bl-strip-out]", d.blStrip, "src");
      });
    });

    /* ---- Accordions (Fragrance Notes / Ingredients) ----
       Single-open per section: opening one closes the other in the same block. */
    function setAcc(btn, open) {
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      var panel = btn.nextElementSibling;
      if (panel && panel.classList.contains("bl-acc__panel")) panel.hidden = !open;
    }
    root.querySelectorAll("[data-bl-acc]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var willOpen = btn.getAttribute("aria-expanded") !== "true";
        var group = btn.closest(".bl-deep__notes");
        if (willOpen && group) {
          group.querySelectorAll("[data-bl-acc]").forEach(function (other) {
            if (other !== btn) setAcc(other, false);
          });
        }
        setAcc(btn, willOpen);
      });
    });

    /* ---- PDP thumbnails (scoped per gallery) ---- */
    root.querySelectorAll("[data-bl-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var scope = btn.closest("[data-bl-scope]") || root;
        var mainImg = scope.querySelector("[data-bl-main]");
        var src = btn.getAttribute("data-bl-thumb-src");
        if (mainImg && src) mainImg.src = src;
        scope.querySelectorAll("[data-bl-thumb]").forEach(function (b) { b.setAttribute("aria-current", "false"); });
        btn.setAttribute("aria-current", "true");
      });
    });

    /* ---- Mobile gallery arrows: cycle the active thumbnail ---- */
    root.querySelectorAll("[data-bl-gal-prev],[data-bl-gal-next]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var scope = btn.closest("[data-bl-scope]") || root;
        var thumbs = Array.prototype.slice.call(scope.querySelectorAll("[data-bl-thumb]"));
        if (!thumbs.length) return;
        var cur = thumbs.findIndex(function (t) { return t.getAttribute("aria-current") === "true"; });
        if (cur < 0) cur = 0;
        var dir = btn.hasAttribute("data-bl-gal-next") ? 1 : -1;
        var nx = (cur + dir + thumbs.length) % thumbs.length;
        thumbs[nx].click();
      });
    });

    /* ---- Review drag-scroll + prev/next arrows (one per review row) ---- */
    root.querySelectorAll("[data-bl-review-row]").forEach(function (row) {
      var down = false, startX = 0, startScroll = 0, moved = false;
      row.addEventListener("pointerdown", function (e) { down = true; moved = false; startX = e.clientX; startScroll = row.scrollLeft; row.style.cursor = "grabbing"; });
      window.addEventListener("pointerup", function () { down = false; row.style.cursor = ""; });
      row.addEventListener("pointermove", function (e) { if (down) { moved = true; row.scrollLeft = startScroll - (e.clientX - startX); } });

      // step = first card width + gap (works for both desktop 360+24 and mobile)
      function step() {
        var card = row.querySelector(".bl-card");
        var gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap) || 24;
        return card ? card.getBoundingClientRect().width + gap : 384;
      }
      var scope = row.closest("[data-bl-scope]") || row.closest("section") || root;
      var prev = scope.querySelector("[data-bl-rev-prev]");
      var next = scope.querySelector("[data-bl-rev-next]");
      if (prev) prev.addEventListener("click", function () { row.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { row.scrollBy({ left: step(), behavior: "smooth" }); });

      // Center the row on load so cards peek on BOTH edges (Figma look).
      function center() { row.scrollLeft = Math.max(0, (row.scrollWidth - row.clientWidth) / 2); }
      center();
      requestAnimationFrame(function () { requestAnimationFrame(center); });
      window.addEventListener("load", center);
    });
  }

  /* ---- Cart drawer integration ----
     The landing template hides the theme header, so a standalone <cart-drawer-component>
     is rendered via the bl-cart-drawer section. Wire the buy-box forms (and the topbar
     bag / cart links) to it: AJAX add → dispatch `cart:update` (the theme drawer auto-opens
     and cart-items-component morphs its section from the response) → open the drawer. */
  function blCartDrawer() { return document.querySelector("cart-drawer-component"); }

  function blOpenCartDrawer() {
    var d = blCartDrawer();
    if (d && typeof d.open === "function") { d.open(); return true; }
    return false;
  }

  // Update the nav "Cart(N)" count. The count is server-rendered plain text,
  // so after an AJAX add we read the fresh total from /cart.js and write it in.
  function blSetCartCount(count) {
    document.querySelectorAll(".barbie-landing .bl-cart-count").forEach(function (el) {
      el.textContent = count;
    });
  }
  function blRefreshCartCount() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { blSetCartCount(cart.item_count); })
      .catch(function (err) { console.error("[barbie] cart count refresh failed", err); });
  }

  function blAjaxAdd(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return; // already adding — ignore repeat submits
    // Swap the CTA label to a busy message while the request is in flight, then restore it.
    var track = btn && btn.querySelector(".bl-cta__label-track");
    var labelTargets = btn ? (track ? track.querySelectorAll("span") : btn.querySelectorAll(".bl-cta__label")) : [];
    var prevLabel = labelTargets.length ? labelTargets[0].textContent : "";
    function setLabel(t) { labelTargets.forEach(function (s) { s.textContent = t; }); }
    var fd = new FormData(form);
    // Ask the response to re-render the drawer's cart-items section so the morph has fresh HTML.
    var items = document.querySelector("cart-drawer-component cart-items-component[data-section-id]");
    if (items && items.dataset.sectionId) fd.append("sections", items.dataset.sectionId);
    var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || "/cart/add.js";
    if (btn) { btn.setAttribute("aria-busy", "true"); btn.disabled = true; setLabel("Adding…"); }
    fetch(url, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/javascript" },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { return; } // e.g. sold out / error — leave the page as-is
        document.dispatchEvent(new CustomEvent("cart:update", {
          bubbles: true,
          detail: { resource: {}, sourceId: "barbie-buybox", data: { source: "product-form-component", sections: res.sections } }
        }));
        blOpenCartDrawer();
        blRefreshCartCount(); // /cart/add.js returns only the added line, so fetch the fresh total
      })
      .catch(function (err) { console.error("[barbie] add to cart failed", err); })
      .finally(function () { if (btn) { btn.removeAttribute("aria-busy"); btn.disabled = false; setLabel(prevLabel); } });
  }

  function initCart() {
    if (window.__barbieCartInit) return;
    window.__barbieCartInit = true;

    // Keep the landing's "Cart(N)" in sync with ANY cart change (add / remove / qty),
    // including changes made inside the theme cart drawer, which fires `cart:update`.
    document.addEventListener("cart:update", blRefreshCartCount);

    document.querySelectorAll(".barbie-landing form.bl-purchase, .barbie-landing form.bl-m-purchase").forEach(function (form) {
      form.addEventListener("submit", function (e) { e.preventDefault(); blAjaxAdd(form); });
    });

    // Topbar bag (mobile) + cart links (desktop) open the drawer instead of navigating.
    document.querySelectorAll('.barbie-landing .bl-m-nav__bag, .barbie-landing .bl-nav--right a[href*="/cart"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (blCartDrawer()) { e.preventDefault(); blOpenCartDrawer(); }
      });
    });
  }

  /* ---- Mobile menu drawer ----
     The theme header (and its menu drawer) are suppressed on this template, so a
     standalone theme <header-drawer> is rendered via the bl-menu-drawer section.
     Open/close it by toggling the drawer's native [open] + `.menu-open` state; the
     header-drawer custom element (once its module upgrades) handles focus-trap and
     its built-in close button / Escape. We fall back to the raw class toggle if the
     element hasn't upgraded yet. */
  function blMenuDrawerEl() { return document.querySelector("#bl-menu-drawer-host header-drawer"); }
  function blMenuDetails() { return document.getElementById("Details-menu-drawer-container"); }
  function blMenuIsOpen(d) { return d.classList.contains("menu-open") || d.hasAttribute("open"); }
  function blToggleMenuDrawer() {
    var hd = blMenuDrawerEl(), d = blMenuDetails();
    if (!d) return;
    if (blMenuIsOpen(d)) {
      if (hd && typeof hd.close === "function") hd.close();
      else { d.classList.remove("menu-open"); d.removeAttribute("open"); }
    } else {
      d.open = true; // reveal <details> content
      if (hd && typeof hd.open === "function") hd.open(); // slide-in + focus trap
      else d.classList.add("menu-open");
    }
  }

  function initMenuDrawer() {
    if (window.__barbieMenuInit) return;
    window.__barbieMenuInit = true;
    document.querySelectorAll(".barbie-landing .bl-m-nav__burger").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        if (blMenuDetails()) { e.preventDefault(); blToggleMenuDrawer(); }
      });
    });
  }

  /* ---- Scroll-linked parallax drift for decorative icons ----
     Purely decorative icons (data-bl-drift) inside a scene (data-bl-parallax-scene)
     fade/scale in and drift outward as the scene scrolls through the viewport, and
     collapse back as it scrolls away. Motion is eased (lerp toward the scroll-derived
     target each frame) so it feels fluid without hijacking native scroll — no library.

     Per-icon tuning lives in the markup:
       data-bl-drift="dx dy"  px offset at full progress (direction + magnitude)
       data-bl-rot="deg"      base rotation to preserve (JS owns the transform) */
  function initParallax() {
    if (window.__barbieParallaxInit) return;
    window.__barbieParallaxInit = true;

    var scenes = [];
    document.querySelectorAll("[data-bl-parallax-scene]").forEach(function (sceneEl) {
      var icons = [];
      sceneEl.querySelectorAll("[data-bl-drift]").forEach(function (el) {
        var parts = (el.getAttribute("data-bl-drift") || "0 0").trim().split(/\s+/);
        el.classList.add("bl-parallax-ready");
        icons.push({
          el: el,
          dx: parseFloat(parts[0]) || 0,
          dy: parseFloat(parts[1]) || 0,
          rot: parseFloat(el.getAttribute("data-bl-rot")) || 0
        });
      });
      if (icons.length) scenes.push({ el: sceneEl, icons: icons, sp: 0, active: false });
    });
    if (!scenes.length) return;

    // Respect reduced-motion: reveal icons static (full opacity, base rotation), no drift.
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      scenes.forEach(function (s) {
        s.icons.forEach(function (ic) {
          ic.el.style.opacity = "1";
          ic.el.style.transform = "translate3d(0,0,0) scale(1) rotate(" + ic.rot + "deg)";
        });
      });
      return;
    }

    var EASE = 0.12;   // how quickly the eased progress catches up to the scroll target
    var ENTER = 0.3;   // fraction of progress over which icons fade + scale in
    var running = false;

    // 0 when the scene's top is at the viewport bottom (entering), ~0.5 centered, 1 when exited up.
    function progressFor(el) {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight;
      return Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
    }

    function render(scene) {
      scene.sp += (progressFor(scene.el) - scene.sp) * EASE;
      var sp = scene.sp;
      var enter = Math.min(1, sp / ENTER);          // entrance ramp
      var opacity = enter;
      var scale = 0.75 + 0.25 * enter;              // 0.75 resting -> 1 in view
      for (var i = 0; i < scene.icons.length; i++) {
        var ic = scene.icons[i];
        ic.el.style.opacity = opacity;
        ic.el.style.transform =
          "translate3d(" + (ic.dx * sp).toFixed(2) + "px," + (ic.dy * sp).toFixed(2) + "px,0) " +
          "scale(" + scale.toFixed(3) + ") rotate(" + ic.rot + "deg)";
      }
    }

    function tick() {
      var stillActive = false;
      for (var i = 0; i < scenes.length; i++) {
        if (!scenes[i].active) continue;
        render(scenes[i]);
        stillActive = true;
      }
      if (stillActive) requestAnimationFrame(tick);
      else running = false;
    }
    function start() { if (!running) { running = true; requestAnimationFrame(tick); } }

    // Only animate scenes that are actually on screen (idle otherwise).
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        for (var i = 0; i < scenes.length; i++) {
          if (scenes[i].el === e.target) { scenes[i].active = e.isIntersecting; break; }
        }
      });
      if (scenes.some(function (s) { return s.active; })) start();
    }, { rootMargin: "10% 0px 10% 0px" });

    scenes.forEach(function (s) { io.observe(s.el); render(s); }); // render() sets initial resting state
  }

  function boot() { document.querySelectorAll(".barbie-landing").forEach(init); initCart(); initMenuDrawer(); initParallax(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".barbie-landing");
    if (el) init(el);
  });
})();
